import { format, isValid, parse } from 'date-fns';
import { stripHtml } from './htmlEntities';

/** The sentence the current WordPress theme shows when a document is under revision. */
export const UNDER_REVISION_SENTENCE =
  'This resource is currently under revision and a new version will be available soon.';

export function isUnderRevision(value: string | boolean | null | undefined): boolean {
  return value === true || value === 'true' || value === '1';
}

const VERSION_LINE =
  /Version\s*:?\s*\d+(?:\.\d+)*(?:\s+Date\s*:\s*\d{4})?(?:\s+[A-Za-z]+\s+\d{1,2},\s+\d{4})?|Released\s+[A-Z][a-z]+\s+\d{1,2},\s+\d{4}|Revised:\s*\S[^\n.]{0,80}/i;

/** The version line authors already write. Returns that phrase only, not the rest of the excerpt. */
export function versionLineFromHtml(html: string | null | undefined): string | null {
  const text = stripHtml(html);
  if (!text) return null;
  const match = text.match(VERSION_LINE);
  if (!match) return null;
  const line = match[0].replace(/\s+/g, ' ').trim();
  return line.length > 0 && line.length < 120 ? line : null;
}

export function formatRevisedDate(value: string | null | undefined): string | null {
  if (!value) return null;

  const iso = parse(value, 'yyyy-MM-dd', new Date());
  if (isValid(iso) && format(iso, 'yyyy-MM-dd') === value) {
    return format(iso, 'MMMM d, yyyy');
  }

  const compact = parse(value, 'yyyyMMdd', new Date());
  if (isValid(compact) && format(compact, 'yyyyMMdd') === value) {
    return format(compact, 'MMMM d, yyyy');
  }

  const dayFirst = parse(value, 'd/M/yyyy', new Date());
  if (isValid(dayFirst) && format(dayFirst, 'd/M/yyyy') === value) {
    return format(dayFirst, 'MMMM d, yyyy');
  }

  return null;
}
